module.exports = __webpack_public_path__ + "static/img/年度最佳性能笔记本.0f6afa45.png";